// AppRouter.js
import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import App from './App' // Import the main App component

function AppRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/customize/:id" element={<App />} />
        <Route path="/customize" element={<App />} />
        <Route path="/" element={<App />} /> // Example of a root path
      </Routes>
    </Router>
  )
}

export default AppRouter
